import '../../../../requestList/services/countryService'
import { RequestConsignee } from '../../../../requestDetailEdit/models/requestConsignee';
import { RequestDetailEdit } from '../../../../requestDetailEdit/models/requestDetailEdit';
import { RequestDetail } from '../../../../requestDetailEdit/models/requestDetail';
import { IConsigneeService } from '../services/consigneeService';
import { ICountryService } from '../../../../requestList/services/countryService';
import { Country } from '../../../../requestList/models/country';
import { Region } from '../models/region';
import { IRegionService } from '../services/regionService';

export class ConsigneeSearchController {
    static $inject = ['ConsigneeService', 'RegionService', 'countryService', '$timeout'];

    requestDetailEdit: RequestDetailEdit;
    isConsigneeSearchLoading: boolean;
    _isConsigneeSelected: boolean;
    showAddConsigneeFields: boolean = false;
    _countryList: Country[];
    searchText: any;
    isUsDestination: boolean = true;
    usRegions: Region[];
    formAddConsigneeFields: ng.IFormController;

    constructor(private _consigneeService: IConsigneeService,
        private _regionService: IRegionService,
        private _countryService: ICountryService,
        private $timeout: ng.ITimeoutService) {
    }

    $onInit() {
        if (this.consigneeNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestConsignee.consigneeId !== undefined) {

            if (this.requestDetailEdit.requestDetail.requestConsignee.consigneeId !== "-1") {
            } else {
                this.addConsigneeFields();
            }
        }   
    }

    loadUsRegions() {
        this._regionService.getRegionsByCountry('US').then(regions => {
            this.usRegions = regions;
        });
    }

    onIsUsDestinationChange() {
        if (this.isUsDestination) {
            this.setDefaultCountry();
            this.loadUsRegions();
        } else {
            this.requestDetailEdit.requestDetail.requestConsignee.countryCode = undefined;
            this.requestDetailEdit.requestDetail.requestConsignee.regionCode = undefined;
        }
    }

    setDefaultCountry() {
        if (this.requestDetailEdit && this.requestDetailEdit.requestDetail && this.requestDetailEdit.requestDetail.requestConsignee) {
            this.requestDetailEdit.requestDetail.requestConsignee.countryCode = 'US';
        }
    }

    consigneeNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee !== undefined;
    }

    get isConsigneeSelected(): boolean {
        if (this._isConsigneeSelected) {
            return true;
        }
        return false;
    }


    queryConsigneeDetails(searchText: string): Promise<RequestConsignee[]> {
        return new Promise<RequestConsignee[]>((resolve, reject) => {
            this._consigneeService.getConsigneeDetails(searchText)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
    }


    editAndEnableSearchConsignee() {
        this.requestDetailEdit.requestDetail.requestConsignee = new RequestConsignee(undefined);
        this._isConsigneeSelected = false;
        if (typeof (this.searchText) == "object")
            this.searchText = "";
    }

    get selectedConsignee(): any {
        if (this.consigneeNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestConsignee.consigneeId !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee.consigneeId !== "-1") {
            this._isConsigneeSelected = true;
            return this.requestDetailEdit.requestDetail.requestConsignee;

        } else {
            this._isConsigneeSelected = false;
            return '';
        }

    }

    set selectedConsignee(val: any) {
        if (val !== undefined && val !== null && val !== '' && val.consigneeId !== undefined && val.consigneeID !== '-1'
        ) {
            this.requestDetailEdit.requestDetail.requestConsignee = new RequestConsignee(val);
        }
    }

    searchTextChange(text) {
        if (text !== undefined) {
            this.showAddConsigneeFields = false;
            this.requestDetailEdit.requestDetail.requestConsignee = new RequestConsignee(undefined);
            angular.element(document.querySelector("md-virtual-repeat-container")).removeClass("ng-hide");
        }
    }

    onCountryChange(countryCode: string) {
        this.requestDetailEdit.requestDetail.requestConsignee
            .country = this.countries.filter(o => o.countryCode === countryCode)[0].countryName;

    }



    isConsigneeParameterHasValue(consigneeeParameter: string): boolean {
        return (consigneeeParameter !== undefined && consigneeeParameter !== null && consigneeeParameter.length > 0);
    }

    addConsigneeFields(): void {
        
        this.showAddConsigneeFields = true;
        if (this.requestDetailEdit.requestDetail.requestConsignee === undefined) {
            this.requestDetailEdit.requestDetail.requestConsignee = new RequestConsignee(undefined);
        }

        if (this.isUsDestination) {
            this.setDefaultCountry();
            this.loadUsRegions();
        }

        this.requestDetailEdit.requestDetail.requestConsignee.consigneeId = "-1";
        this.searchText = "";
        this._countryService.getCountryList().then(o => this.handleCountryList(o));
        this.$timeout(() => {
            document.getElementById('ConsigneeNameID').focus();
        });
        angular.element(document.querySelector("md-virtual-repeat-container")).addClass("ng-hide");
    }


    handleCountryList(options: Country[]): void {

        this._countryList = options;
        this.isConsigneeSearchLoading = false;
    }

    get countries(): Country[] {
        return this._countryList;
    }

    handleCountryOpen(): void {
        this.requestDetailEdit.requestDetail.requestConsignee.countryCode = undefined;
    }

get isConsigneeSearchValid(): boolean {


        if (this.requestDetailEdit === undefined ||
            this.requestDetailEdit.requestDetail === undefined ||
            this.requestDetailEdit.requestDetail.requestConsignee === undefined ||
            this.requestDetailEdit.requestDetail.requestConsignee.consigneeId === undefined
            || this.requestDetailEdit.requestDetail.requestConsignee.consigneeId === null) {
            
            return false;
            
        }


        if (this.consigneeNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestConsignee.consigneeId === "-1") {
                return this.formAddConsigneeFields ? this.formAddConsigneeFields.$valid : false;
        }

        

        return true;
    }

    set isConsigneeSearchValid(val: boolean) {
        
    }

    // getValidItemProperties(item: any) {
    //     var validItems = [];
    //     if (this.isConsigneeParameterHasValue(item.consigneeName1)) {
    //         validItems.push(item.consigneeName1);
    //     }

    //     if (this.isConsigneeParameterHasValue(item.consigneeName2)) {
    //         validItems.push(item.consigneeName2);
    //     }

    //     if (this.isConsigneeParameterHasValue(item.consigneeName3)) {
    //         validItems.push(item.consigneeName3);
    //     }

    //     if (this.isConsigneeParameterHasValue(item.consigneeName4)) {
    //         validItems.push(item.consigneeName4);
    //     }

    //     if (this.isConsigneeParameterHasValue(item.consigneeStreet1)) {
    //         validItems.push(item.consigneeStreet1 + (this.isConsigneeParameterHasValue(item.consigneeHouseNumber) ? (" " + item.consigneeHouseNumber) : ''));
    //     }

    //     if (this.isConsigneeParameterHasValue(item.consigneeStreet2)) {
    //         validItems.push(item.consigneeStreet2);
    //     }

    //     if (this.isConsigneeParameterHasValue(item.consigneeStreet3)) {
    //         validItems.push(item.consigneeStreet3);
    //     }

    //     if (this.isConsigneeParameterHasValue(item.consigneeStreet4)) {
    //         validItems.push(item.consigneeStreet4);
    //     }

    //     var cityAndRegion = item.city + (this.isConsigneeParameterHasValue(item.regionCode)  ? ", " +
    //         item.regionCode : "");
    //     validItems.push(cityAndRegion);

    //     var postalAndCountry = item.postalCode + " " + item.country;
    //     validItems.push(postalAndCountry);

    //     return validItems;
    // }

}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/consigneeSearch/controllers/consigneeSearchController.ts
 **/